
import type { UserAbridged } from "@/types/AbridgedResponse";
import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getUserServiceEndPoint } from "./base-url/api-constants";
import { getAuthHeader, readCookie } from "@/utils/helper";

class UserService {
  UserService(url: any) {
    return getUserServiceEndPoint(url);
  }

  createUser(data: any) {
    const createUserEndpoint = this.UserService(`${endPoints.userService.CREATE_USER}`);
    return apiService.post(createUserEndpoint, data);
  }
  createExternalUser(data: any) {
    const createUserEndpoint = this.UserService(`${endPoints.userService.CREATE_EXTERNAL_USER}`);
    return apiService.post(createUserEndpoint, data);
  }
  loginUser(data: any) {
    const loginUserEndpoint = this.UserService(`${endPoints.userService.CREATE_USER}`);
    return apiService.post(loginUserEndpoint, data);
  }
  updatePassword(data: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const updateUserPwdEndpoint = this.UserService(`${endPoints.userService.UPDATE_PWD}`);
    return apiService.post(updateUserPwdEndpoint, data, headers);
  }
  resetPassword(data: any) {
    const resetPasswordEndpoint = this.UserService(`${endPoints.userService.RESET_PWD}`);
    return apiService.post(resetPasswordEndpoint, data);
  }
  forgotPassword(data: any) {
    const forgotPasswordEndpoint = this.UserService(`${endPoints.userService.FORGOT_PWD}`);
    return apiService.patch(forgotPasswordEndpoint, data);
  }
  getUserProfile(userGuid: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const serviceEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_PROFILE.replace(":userGuid", userGuid)}`
    );
    return apiService.get(serviceEndpoint, null, headers);
  }
  signinAsAdmin(data: any) {
    const signinAsAdminEndpoint = this.UserService(`${endPoints.userService.SIGNIN_AS_ADMIN}`);
    return apiService.post(signinAsAdminEndpoint, data);
  }
  getUserByUserName(userName: any) {
    const jwtToken = readCookie("jwtToken"); //localStorage.getItem("jwtToken");
    const headers = { Authorization: "Bearer" + " " + jwtToken };
    const getUserByUserNameEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_USERNAME.replace(":username", userName)}`
    );
    return apiService.get(getUserByUserNameEndpoint, null, headers);
  }
  getUserByEmail(email: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const getUserByEmailEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_EMAIL.replace(":email", email)}`
    );
    return apiService.get(getUserByEmailEndpoint, null, headers);
  }
  getUserByUserGuid(userGuid: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const getUserByUserGuidEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_BY_GUID.replace(":guid", userGuid)}`
    );
    return apiService.get(getUserByUserGuidEndpoint, null, headers);
  }

  getUserObject(): Promise<UserAbridged> {
    const jwtToken = readCookie("jwtToken");
    if (!jwtToken) {
      return Promise.reject(new Error("Missing user JWT for abridged profile request."));
    }

    const headers = { Authorization: `Bearer ${jwtToken}` };
    const endpoint = this.UserService(`${endPoints.userService.GET_USER_OBJECT}`);
    return apiService.get(endpoint, null, headers, { skipErrorPopup: true });
  }
  loginAttempt(data: any) {
    const loginAttemptEndpoint = this.UserService(`${endPoints.userService.LOGIN_ATTEMPT}`);
    return apiService.post(loginAttemptEndpoint, data);
  }
  getCaptchaScore(greToken: any, portal: any) {
    const getCaptchaScoreEndpoint = this.UserService(
      `${endPoints.userService.RECAPTCHA_SCORE.replace(":greToken", greToken).replace(":portal", portal)}`
    );
    return apiService.get(getCaptchaScoreEndpoint);
  }
  validateLgctExpiry(token: any) {
    const getValidateLgctTokenEndPoint = this.UserService(
      `${endPoints.userService.VALIDATE_LGCT_EXPIRY.replace(":token", token)}`
    );
    return apiService.get(getValidateLgctTokenEndPoint);
  }
  saveUserAddress(userAddress: any) {
    const headers = { Authorization: "Bearer" + " " + readCookie("jwtToken") };
    const saveUserAddressEndPoint = this.UserService(`${endPoints.userService.SAVE_USER_ADDRESS}`);
    return apiService.post(saveUserAddressEndPoint, userAddress, headers);
  }
  getIp2Connect(ipAddress: any) {
    const saveUserAddressEndPoint = this.UserService(
      `${endPoints.userService.IP_2_CONNECT.replace(":ipaddress", ipAddress)}`
    );
    return apiService.get(saveUserAddressEndPoint);
  }
  getUserProfileAbridged(userGuid: any) {
    const serviceEndpoint = this.UserService(
      `${endPoints.userService.GET_USER_PROFILE_ABRIDGED.replace(":userGuid", userGuid)}`
    );
    return apiService.get(serviceEndpoint, null, getAuthHeader(), {
      skipErrorPopup: true,
    });
  }
}

export default new UserService();
